"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
var _Label = _interopRequireDefault(require("./Label"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }